let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("a0CG9")).then(() => parcelRequire('2Bq9l'));